module.exports = __webpack_public_path__ + "img/studycommentPlin.02974085.svg";